import type * as React from 'react'

import { StatusGate } from '@/components/status-gate'
import { useCore, type CoreStatus } from '@/modules/projects/store'

/**
 * Fica num arquivo separado do `StatusGate` de propósito: este importa o
 * store (e, por ele, a sessão e o `env.ts`, que exige variáveis de ambiente);
 * o gate puro é testável sem nada disso.
 */
export type CoreDomain = keyof CoreStatus

/**
 * `StatusGate` ligado ao store: a rota declara de quais cargas depende e o
 * "Tentar novamente" refaz só essas.
 */
export function CoreGate({
  domains,
  children,
}: {
  domains: readonly CoreDomain[]
  children: React.ReactNode
}) {
  const core = useCore()
  const reloaders: Record<CoreDomain, () => Promise<void>> = {
    projects: core.reloadProjects,
    people: core.reloadPeople,
    core: core.reloadCore,
  }
  const statuses = domains.map((d) => core.status[d])
  const retry = () => {
    for (const d of domains) {
      if (core.status[d].kind === 'erro') void reloaders[d]()
    }
  }
  return (
    <StatusGate status={statuses} onRetry={retry}>
      {children}
    </StatusGate>
  )
}
